const loginBrands = [
  { key: "avva", name: "AVVA", file: "avva.svg" },
  { key: "derimod", name: "DERİMOD", file: "derimod.svg" },
  { key: "uspa", name: "U.S. POLO ASSN.", file: "uspa.png" },
  { key: "dsdamat", name: "D’S DAMAT", file: "dsdamat.svg" },
  { key: "damattween", name: "DAMAT / TWEEN", file: "damattween.svg" },
  { key: "instreet", name: "IN STREET", file: "instreet.svg" },
  { key: "adl", name: "adL", file: "adl.svg" },
  { key: "penti", name: "Penti", file: "penti.svg" },
  { key: "madamecoco", name: "MADAME COCO", file: "madamecoco.svg" },
  { key: "reebok", name: "Reebok", file: "reebok.png" },
] as const;

export default function LoginBrandStrip() {
  return (
    <footer className="login-brands">
      {loginBrands.map((brand) => (
        <div className={`login-brands__item login-brands__item--${brand.key}`} key={brand.key}>
          <img src={`/login-20261103/${brand.file}`} alt={brand.name} decoding="async" />
          {brand.key === "reebok" ? <span className="login-brands__caption" aria-hidden="true">Reebok</span> : null}
        </div>
      ))}
    </footer>
  );
}
